const GOOGLE_REVIEWS_PLUGIN_ASSEMBLY = 'Syple.Velocity.Plugins.GoogleReviews';
const PLACES_API_KEY_FIELD_ID = 'PlacesApiKey';

export const GOOGLE_REVIEWS_SETUP_STATES = Object.freeze({
    configured: 'configured',
    notConfigured: 'not-configured',
    unknown: 'unknown'
});
export const GOOGLE_REVIEWS_SETUP_MESSAGE = "Google Reviews isn't fully set up yet. Add a Places API key in Settings > Apps & Integrations > Google Reviews, then add a Google Place ID in Settings > Business > Locations.";

let setupStatePromise = null;

const normalizeFieldsets = (formPayload) => {
    const fieldsets = formPayload?.fieldsets ?? formPayload?.Fieldsets;
    return Array.isArray(fieldsets) ? fieldsets : [];
};

const normalizeFields = (fieldset) => {
    const fields = fieldset?.fields ?? fieldset?.Fields;
    return Array.isArray(fields) ? fields : [];
};

const extractPlacesApiKey = (formPayload) => {
    const fieldsets = normalizeFieldsets(formPayload);
    for (const fieldset of fieldsets) {
        const fields = normalizeFields(fieldset);
        const field = fields.find(item => {
            const id = String(item?.id ?? item?.Id ?? item?.name ?? item?.Name ?? '').trim();
            return id === PLACES_API_KEY_FIELD_ID;
        });

        if (!field) {
            continue;
        }

        const value = String(field?.value ?? field?.Value ?? '').trim();
        return value;
    }

    return '';
};

const getPluginFromLibrary = (payload) => {
    if (!Array.isArray(payload)) {
        return null;
    }

    return payload.find(item => {
        const assembly = String(item?.assemblyName ?? item?.AssemblyName ?? '').trim();
        return assembly === GOOGLE_REVIEWS_PLUGIN_ASSEMBLY;
    }) || null;
};

const toUnknown = () => GOOGLE_REVIEWS_SETUP_STATES.unknown;

export const clearGoogleReviewsSetupStateCache = () => {
    setupStatePromise = null;
};

export const getGoogleReviewsSetupState = async () => {
    if (setupStatePromise) {
        return setupStatePromise;
    }

    setupStatePromise = (async () => {
        try {
            const libraryResponse = await fetch('/api/v2/plugins/library');
            if (!libraryResponse.ok) {
                return toUnknown();
            }

            const libraryPayload = await libraryResponse.json();
            const plugin = getPluginFromLibrary(libraryPayload);
            if (!plugin) {
                return GOOGLE_REVIEWS_SETUP_STATES.notConfigured;
            }

            const isEnabled = plugin?.enabled ?? plugin?.Enabled;
            if (!isEnabled) {
                return GOOGLE_REVIEWS_SETUP_STATES.notConfigured;
            }

            const formResponse = await fetch(`/api/v2/plugins/${encodeURIComponent(GOOGLE_REVIEWS_PLUGIN_ASSEMBLY)}/form`);
            if (!formResponse.ok) {
                return toUnknown();
            }

            const formPayload = await formResponse.json();
            const placesApiKey = extractPlacesApiKey(formPayload);
            if (!placesApiKey) {
                return GOOGLE_REVIEWS_SETUP_STATES.notConfigured;
            }

            return GOOGLE_REVIEWS_SETUP_STATES.configured;
        } catch (error) {
            return toUnknown();
        } finally {
            setupStatePromise = null;
        }
    })();

    return setupStatePromise;
};
